/*
 * The browser tab icon: the Steward mark in the colors of the brand at this web address (app.thecleanersusa.com shows
 * The Cleaners' teal, app.thegroundsmen.com The GroundsMen's green), so a row of Steward tabs is easy to tell apart, like
 * the old Steward's tab icon. Head office's address, a PC and the preview keep the black and white mark.
 */
import { stewardMarkFor, stewardMarkSvg, type StewardMark } from "@steward/shared";

export function setTabIcon(mark: StewardMark = stewardMarkFor("hq")) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.type = "image/svg+xml";
  link.href = `data:image/svg+xml,${encodeURIComponent(stewardMarkSvg(mark))}`;
}
